import './style/App.css';
import { useEffect } from 'react';
import About from './components/About';
import Footer from './components/Footer';
import Partners from './components/Partners';
import Services from './components/Services';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import StatsStrip from './components/StatsStrip';
import VisionMission from './components/VisionMission';
import AboutPage from './pages/AboutPage';
import QuotePage from './pages/QuotePage';
import ContactPage from './pages/ContactPage';

function App() {
  const isContactPage =
    typeof window !== 'undefined' && window.location.pathname === '/contact';
  const isQuotePage =
    typeof window !== 'undefined' && window.location.pathname === '/quote';
  const isAboutPage =
    typeof window !== 'undefined' && window.location.pathname === '/about';

  useEffect(() => {
    if (typeof window === 'undefined' || isAboutPage || isQuotePage || isContactPage) {
      return undefined;
    }

    const scrollToHashTarget = () => {
      const hash = window.location.hash;
      if (!hash) return;
      const targetId = hash.replace('#', '');
      if (!targetId) return;

      let tries = 0;
      const maxTries = 30;

      const attempt = () => {
        const target = document.getElementById(targetId);
        if (target) {
          const nav = document.querySelector('.Navbar');
          const navOffset = nav ? nav.offsetHeight + 8 : 90;
          const top = target.getBoundingClientRect().top + window.scrollY - navOffset;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          return;
        }

        if (tries < maxTries) {
          tries += 1;
          window.requestAnimationFrame(attempt);
        }
      };

      attempt();
    };

    scrollToHashTarget();
    window.addEventListener('hashchange', scrollToHashTarget);
    return () => window.removeEventListener('hashchange', scrollToHashTarget);
  }, [isAboutPage, isQuotePage, isContactPage]);

  if (isContactPage) {
    return <ContactPage />;
  }

  if (isQuotePage) {
    return <QuotePage />;
  }

  if (isAboutPage) {
    return <AboutPage />;
  }

  return (
    <div className="App" id="home">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <VisionMission />
      <StatsStrip />
      <Partners />
      <Footer />
    </div>
  );
}

export default App;
